import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  SubmitButton,
} from '../../../styles/Modal'
import { IoCloseCircleSharp, IoArrowBack } from 'react-icons/io5'
import { FaEye } from 'react-icons/fa'
import { carregarDistribuidores } from '../../../services/dists'
import DistMultipleSelector from '../../Common/DistMultipleSelector'

interface PropsVisualizador {
  name: string
  setName: (text: string) => void
  email: string
  setEmail: (text: string) => void
  password: string
  setPassword: (text: string) => void
  nickname: string
  setNickname: (text: string) => void
  phone: string
  setPhone: (text: string) => void
  role: string
  setRole: (text: string) => void
  loading: boolean
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleClick: () => void
  setCloseModal: () => void
  handleBack?: () => void
  distsVisualizador?: number[]
  setDistsVisualizador?: (ids: number[]) => void
}

function ModalVisualizador({
  email,
  password,
  name,
  nickname,
  phone,
  loading,
  setName,
  setEmail,
  setPassword,
  setNickname,
  handlePhoneChange,
  handleClick,
  setCloseModal,
  handleBack,
  distsVisualizador = [],
  setDistsVisualizador,
}: PropsVisualizador) {
  const [distsList, setDistsList] = useState<any[]>([])

  useEffect(() => {
    carregarDistribuidores().then((res) => {
      setDistsList(res)
    })
  }, [])

  const handleGeneratePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*'
    let newPassword = ''

    for (let i = 0; i < 12; i++) {
      newPassword += chars.charAt(Math.floor(Math.random() * chars.length))
    }

    setPassword(newPassword)
    navigator.clipboard.writeText(newPassword)
    toast.success('Senha gerada e copiada para a área de transferência!')
  }

  return (
    <ModernModalBackdrop>
      <ModernVerticalModal style={{ maxWidth: '560px' }}>
        <div className="header">
          {handleBack && (
            <button className="btn-back" onClick={handleBack} type="button">
              <IoArrowBack />
            </button>
          )}
          <h3>Cadastro de Visualizador</h3>
          <button className="btn-close" onClick={setCloseModal} type="button">
            <IoCloseCircleSharp />
          </button>
        </div>

        <div className="body" style={{ maxHeight: '82vh', overflowY: 'auto' }}>
          {/* Card Didático Explicativo */}
          <div
            style={{
              background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.12), rgba(126, 34, 206, 0.12))',
              border: '1px solid rgba(192, 132, 252, 0.25)',
              borderRadius: '12px',
              padding: '14px 16px',
              display: 'flex',
              gap: '12px',
              alignItems: 'flex-start',
            }}
          >
            <FaEye style={{ fontSize: '24px', color: '#c084fc', flexShrink: 0, marginTop: '2px' }} />
            <div style={{ fontSize: '12px', color: '#cbd5e1', lineHeight: '1.5' }}>
              <strong style={{ color: '#ffffff', display: 'block', marginBottom: '2px', fontSize: '13px' }}>
                Perfil Visualizador Analítico (Mais de 1 Distribuidor)
              </strong>
              O visualizador possui permissão de leitura analítica em dashboards e relatórios. Você pode selecionar um ou múltiplos distribuidores autorizados para ele consultar.
            </div>
          </div>

          {/* Seletor Múltiplo de Distribuidores */}
          {setDistsVisualizador && (
            <ModalFieldGroup>
              <DistMultipleSelector
                dists={distsList}
                selectedIds={distsVisualizador}
                onChange={setDistsVisualizador}
                label="Distribuidores Autorizados (Pode ver mais de 1)"
              />
            </ModalFieldGroup>
          )}

          <ModalFieldGroup>
            <ModalLabel>Usuário (Login) *</ModalLabel>
            <ModalInput
              type="text"
              value={nickname}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, '')
                setNickname(value)
              }}
              placeholder="Digite o login de acesso"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Nome Completo *</ModalLabel>
            <ModalInput
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Digite o nome completo"
              style={{ textTransform: 'capitalize' }}
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Senha *</ModalLabel>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <ModalInput
                type="text"
                value={password}
                placeholder="Gerar senha ou digitar"
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', paddingRight: '120px' }}
              />
              <button
                type="button"
                onClick={handleGeneratePassword}
                style={{
                  position: 'absolute',
                  right: '8px',
                  background: '#7c3aed',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: '6px 12px',
                  color: '#ffffff',
                  fontWeight: 600,
                }}
              >
                Gerar & Copiar
              </button>
            </div>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>E-mail *</ModalLabel>
            <ModalInput
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ex: visualizador@grupogsa.com.br"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Telefone *</ModalLabel>
            <ModalInput
              type="text"
              value={phone}
              onChange={handlePhoneChange}
              maxLength={15}
              placeholder="(00) 00000-0000"
            />
          </ModalFieldGroup>

          <SubmitButton type="button" onClick={handleClick} disabled={loading}>
            {loading ? 'Carregando...' : 'Criar Visualizador'}
          </SubmitButton>
        </div>
      </ModernVerticalModal>
    </ModernModalBackdrop>
  )
}

export default ModalVisualizador
